import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@ohif/ui';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.pathname.includes('patientReports')) {
      navigate(-1);
    } else if (
      [
        '/patientReportImages',
        '/patientRelatedReports',
        '/patientReference',
        '/patientMeasurements',
      ].includes(location.pathname)
    ) {
      navigate('/reports');
    } else {
      navigate(-1);
    }
  };

  const showBackButton =
    location.pathname.includes('patientReports') ||
    [
      '/patientReportImages',
      '/patientRelatedReports',
      '/patientReference',
      '/patientMeasurements',
    ].includes(location.pathname) ||
    location.pathname.startsWith('/templates/preview') ||
    location.pathname.startsWith('/express') ||
    location.pathname.startsWith('/distribution');

  return (
    showBackButton && (
      <button
        className="backBtn"
        onClick={handleBack}
      >
        <Icon name="back-icon" />
        {(location.pathname.includes('patientReports') || location.pathname.includes('/templates/preview/') || location.pathname.includes('/express/') || location.pathname.includes('/distribution/')) && <span className='text-white'>Back</span>}
      </button>
    )
  );
};

export default BackButton;
